import {BUTTON_LABELS} from '@github-ui/issue-viewer/ButtonLabels'
import {AlertFillIcon, type Icon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {clsx} from 'clsx'
import type {FC} from 'react'

import styles from './ListError.module.css'

export type ListErrorProps = {
  title: string
  message: string
  retry?: () => void
  icon?: Icon
  retryText?: string
  testid?: string
}

export const ListError: FC<ListErrorProps> = ({retry, icon, title, message, retryText, testid}) => (
  <div className="blankslate" data-testid={testid}>
    <Octicon className={clsx('blankslate-icon', styles.errorIcon)} icon={icon ?? AlertFillIcon} />
    <h3 className="blankslate-heading">{title}</h3>
    <p className={styles.errorMessage}>{message}</p>
    {retry && (
      <Link as="button" underline onClick={retry} className={styles.retryLink}>
        {retryText ?? BUTTON_LABELS.tryAgain}
      </Link>
    )}
  </div>
)

try{ ListError.displayName ||= 'ListError' } catch {}